import BaseClient from '@/app/model/api/response/baseApiClient'

class PasswordHashCheckApi extends BaseClient {
  public doPasswordHashCheck (bodyData: {[key: string]: string}) {
    const path = '/v1/reminder/user/hash/check'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new PasswordHashCheckApi()
